<template>
    <div>
        <v-dialog v-model="articleCategoryDialog" max-width="650" persistent>
            <v-card tile max-height="85vh">
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">{{ editCategory ? 'ویرایش دسته‌بندی' : 'دسته‌بندی جدید' }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="articleCategoryDialog = false">
                        <v-icon size="23" color="primary">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form" class="px-6 pt-3">
                    <switch-input v-model="form.status" label="وضعیت"></switch-input>
                    <v-text-field
                        :rules="$validation('required')"
                        label="* عنوان دسته‌بندی"
                        v-model="form.name"
                    ></v-text-field>
                    <v-select
                        :items="$system.kbParentCategories.filter(x => x.id != editCategory)"
                        item-title="name"
                        item-value="id"
                        label="دسته‌بندی والد"
                        no-data-text="موردی پیدا نشد!"
                        :disabled="editCategory && !$system.kbArticleCategories.some(x => x.id == editCategory)"
                        clearable
                        v-model="form.parent_id"
                    ></v-select>
                    <v-row dense align="stretch">
                        <v-col cols="auto">
                            <file-input
                                :text="`<div class='text-small d-flex flex-column h-100 justify-center align-center'><span class='font-weight-medium'>آپلود آیکون</span><span class='d-block'>فرمت: png</span><span class='d-block mt-n2'>ابعاد: 18 * 18</span></div>`"
                                :style="{backgroundColor: '#e7e7e7', borderRadius: '4px', height: '120px', width: '120px'}"
                                :types="['png']"
                                :mimeTypes="['image/png']"
                                :size="512000"
                                type="image"
                                imageSize="fill"
                                ref="iconInput"
                                @updated="iconChanged"
                            ></file-input>
                        </v-col>
                        <v-col>
                            <v-textarea
                                :rules="$validation()"
                                label="توضیحات"
                                no-resize
                                hide-details
                                v-model="form.description"
                                rows="6"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-card-actions class="py-3 px-5 bg-white">
                        <v-btn color="success" variant="flat" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="articleCategoryDialog = false" variant="text" :disabled="loading">بستن</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            form: {
                status: false,
                name: null,
                parent_id: null,
                description: null,
            },
            icon: null,
            articleCategoryDialog: false,
            editCategory: false,
        };
    },
    methods: {
        async submit() {
            this.loading = true;
            let res = !this.editCategory ? await this.$knowledgebaseCategoryStore(this.$object.toFormData(this.form)) :
                await this.$knowledgebaseCategoryUpdate(this.editCategory, this.$object.toFormData({...this.form, _method: 'put'}));
            if (res && (res.status == "CREATED" || res.status == "UPDATED")) {
                this.$toast.success("عملیات با موفقیت انجام شد.");
                this.$system.setKbParentCategories(true);
                this.articleCategoryDialog = false;
                this.$emit('getCategoryList')
            }
            this.loading = false;
        },
        iconChanged() {
            let file = this.$refs.iconInput.getValidFiles();
            this.form.icon = file == null ? 'unset' : file['file'];
        },
        edit(item) {
            this.articleCategoryDialog = true;
            this.icon = item.icon ?? false;
            this.form = {
                status: item.status,
                name: item.name,
                parent_id: item.parent_id,
                description: item.description,
            };
            this.editCategory = item.id;
        },
        create() {
            this.articleCategoryDialog = true;
            this.editCategory = false;
            this.icon = false;
            this.form = { name: null, parent_id: null, status: true, description: null };
        }
    },
    watch: {
        articleCategoryDialog() {
            if(this.articleCategoryDialog)
                setTimeout(() => {
                    if(this.icon)
                        this.$refs.iconInput.setImageFileFromServer(this.icon)
                }, 1000);
            else
                this.$refs.iconInput.clearFile(false);
            if (this.$refs.form)
                this.$refs.form.resetValidation();
        }
    },
    mounted() {
        this.$system.setKbParentCategories();
    },
};
</script>
